import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable , throwError } from 'rxjs';
import {catchError, map, tap} from 'rxjs/operators';
import {RestUrlsConfig} from '@signature-it/ngx-generic/config';
import { IUser } from '@signature-it/ngx-generic/interfaces';
import { UserPropertyActionDTO, UserPropertyFieldDTO, FormDTO } from '@signature-it/ngx-generic/models';
import { CommonService } from "../services/common.service";
import {PageNotificationService} from './page-notification';
import { B2BSubUserDTO } from '@signature-it/ngx-generic/models';


declare let _: any;

@Injectable({
    providedIn: 'root'
})
export class SubUsersService extends CommonService {
    protected subUsersUrl = `${this.restUrlsConf.appURL}/public/sub-users/list.json`;
    protected addNewSubUserUrl = `${this.restUrlsConf.appURL}/public/sub-users/add.json`;
    protected updateSubUserUrl = `${this.restUrlsConf.appURL}/public/sub-users/update.json`;
    protected sendActivationEmailUrl = `${this.restUrlsConf.appURL}/public/sub-users/send-activation-email.json`;

    constructor(protected http: HttpClient,
                protected restUrlsConf: RestUrlsConfig,
                protected notifySvc: PageNotificationService) {
        super(http, restUrlsConf, notifySvc);
    }

    /**
     *
     * @returns Observable<any>
     */
    getUsers(search): Observable<any> {
        const qp = search ? `?search=${search}`: '';
        return this.http.get(this.subUsersUrl + qp)
            .pipe(map((res) => {
                    return {
                        data: res['data'],
                        actions: UserPropertyActionDTO.create(res['actions']),
                        fields: UserPropertyFieldDTO.createFromArray(res['fields']),
                        form: FormDTO.create(res['form'])
                    }
                }), catchError( (error: any) => throwError(error)));
    }

    /**
     *
     * @param any params
     * @returns Observable<any>
     */
    addNewUser(params: any): Observable<any> {
        return this.http.post(this.addNewSubUserUrl, JSON.stringify(params))
            .pipe(map((res: any) => {
                return res;
            }), catchError( (error: any) => throwError(error)));
    }

    /**
     *
     * @returns Observable<any>
     */
    updateUser(params: any): Observable<any> {
        return this.http.post(this.updateSubUserUrl, JSON.stringify(params))
            .pipe(map((res: any) => {
                return res;
            }), catchError( (error: any) => throwError(error)));
    }

    /**
     *
     * @param number uid (user_id)
     * @returns Observable<boolean>
     */
    sendActivationEmail(uid: number): Observable<boolean> {
        const url = `${this.restUrlsConf.appURL}/public/sub-users/${uid}/send-activation-email.json`;
        return this.http.get(url)
            .pipe(map((res: boolean) => res),
                catchError( (error: any) => throwError(error)));
    }
}
